import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import StyledPopover from './StyledPopover.style';

import { OptionType } from 'pages/PatientDetails/containers/components/PatientRecovery/components/ButtonGroup';

const AddRecoveryPlanPopover: React.FC<{
  anchorEl: Element | null;
  onClose: () => void;
  onClick: (option: OptionType) => void;
  jointOptions: OptionType[];
}> = (props) => {
  return (
    <StyledPopover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box padding={3}>
        <Typography mb={1} fontWeight="bold">
          Select joint
        </Typography>
        <Grid
          container
          flexDirection="column"
          borderRadius="10px"
        >
          {Boolean(props.jointOptions.length)
            ? props.jointOptions.map((option) => (
              <Button
                className='popover-button'
                variant="contained"
                onClick={() => props.onClick(option)}
                sx={{ mb: 1 }}
              >
                {option.label}
              </ Button>
            ))
            : <div>No available options</div>
          }
        </Grid>
      </Box>
    </StyledPopover >
  );
}

export default AddRecoveryPlanPopover;
